import { useMemo } from "react";

import { useIdentifier } from "@/hooks/useIdentifier";

export function useSwipeHandlerName() {
  const swiperHandlerClassName = useIdentifier({ prefix: "swipe-handler" });
  const swiperHandlerSelector = useMemo(() => `.${swiperHandlerClassName}`, [swiperHandlerClassName]);

  return {
    swiperHandlerClassName,
    swiperHandlerSelector,
  };
}
